import { HttpClientService } from './../httpClient/httpclient.service';
import { Injectable } from '@angular/core';

@Injectable()
export class CouponRecipientListService {
  baseUrl = 'koncentro-promo/campaign';

  constructor(private http: HttpClientService) { }

  saveRecipientListName(data: {name: string}) {
    return this.http.post(this.baseUrl + '/distribution_list', data);
  }

  saveRecipientListClusterhead(data: {distribution_list_id: number, cluster_head_id_array: string[]}) {
    return this.http.post(this.baseUrl + '/distribution_list_cluster_head/cluster-head', data);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/campaign-2.0/coupon-recipient-list.service.ts